import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CommonModule } from '@angular/common';

import { CustomModalModule } from '@shared/custom-modal/custom-modal.module';
import { FocusDirective } from './directives';
import { VerifyPhoneNumberComponent, VerifyPhoneNumberDashboardComponent } from './components';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';
import { InputPhoneModule } from '@shared/input-phone/input-phone.module';

@NgModule({
  imports: [TranslateModule, FormWrapperModule, CommonModule, ModalModule, CustomModalModule, InputPhoneModule],
  exports: [VerifyPhoneNumberComponent, VerifyPhoneNumberDashboardComponent, FocusDirective],
  declarations: [VerifyPhoneNumberComponent, VerifyPhoneNumberDashboardComponent, FocusDirective],
})
export class VerifyPhoneNumberModule {}
